// Dependencies
require("webstrap/type");
require("webstrap/responsive-embed");
require("grid");

// Styles
require("./video-1-1.scss");

const cookieUtils = require("cookies-utils");

function initVideo(video) {
  const videoSrc = video.dataset.videoSrc;
  const cookieNotice = video.querySelector("[data-video-cookie-notice]");

  function getConsent() {
    return cookieUtils.hasConsent("targeting");
  }

  // Make sure video is set
  if (!videoSrc) return;

  const iframe = document.createElement("iframe");
  iframe.className = "embed-responsive-item";
  iframe.src = videoSrc;
  iframe.width = "100%";
  iframe.height = "100%";
  iframe.frameBorder = 0;
  iframe.allow =
    "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture";
  iframe.allowfullscreen = "";

  if (getConsent()) {
    video.appendChild(iframe);
  } else {
    cookieNotice.classList.remove("hidden");
  }

  const enableVideoBtn = video.querySelector("[data-video-enable]");

  if (enableVideoBtn) {
    enableVideoBtn.addEventListener("click", () => {
      cookieNotice.classList.add("cookie-notice-1-1--hidden");
      video.appendChild(iframe);
    });
  }
}

Array.from(document.querySelectorAll("[data-video]")).forEach((x) => {
  initVideo(x);
});



//////////////////
// WEBPACK FOOTER
// ./LeLab.DomaineForget.Web/src/modules/catalog/video-1/view-1/index.js
// module id = 239
// module chunks = 0